var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"default"},on:{"click":function($event){return _vm.getCode()}}},[_vm._v("Получить код\n  "),(_vm.loading)?_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"18"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }